export default __webpack_public_path__ + "static/context-do-1-dark-be637f1b54570f2f71ac0423a3c0454c.png";